import { useParams } from 'react-router-dom';
import AnalyticsPage from '@/pages/AnalyticsPage';

export default function TeamAnalyticsTab() {
  const { teamId } = useParams<{ teamId: string }>();
  if (!teamId) return null;
  return <AnalyticsPage embeddedTeamId={teamId} />;
}
